import React, { useState, useContext, useEffect } from "react";
import "../Expenses/Expenses.css";
import "./Income.css";
import AuthContext from "../store/auth-context";

function Incomes(props) {
  const [incomeSource, setIncomeSource] = useState("");
  const [incomeAmount, setIncomeAmount] = useState("");

  const authCtx = useContext(AuthContext);

  useEffect(() => {
    authCtx.setTotalIncome(0);
    getIncomes();
  }, []);

  function addIncome(event) {
    event.preventDefault();
    const newIncome = {
      source: incomeSource,
      amount: incomeAmount,
    };
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/incomes.json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "POST",
      body: JSON.stringify({
        source: incomeSource,
        amount: incomeAmount,
      }),
      header: {
        "Content/type": "application/json",
      },
    })
      .then((res) => {
        if (res.ok) {
          return res.json();
        }
      })
      .then((res) => {
        let i = { source: incomeSource, amount: incomeAmount, id: res["name"] };
        authCtx.setIncomes((prevIncomes) => {
          return [i, ...prevIncomes];
        });
        authCtx.setTotalIncome((prev) => {
          return parseFloat(prev) + parseFloat(incomeAmount);
        });
        setIncomeSource("");
        setIncomeAmount("");
      });
  }

  function getIncomes() {
    authCtx.setIncomes([]);
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/incomes.json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "GET",
      header: {
        "Content/type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        for (const incomeObj in res) {
          const income = {
            source: res[incomeObj].source,
            amount: res[incomeObj].amount,
            id: incomeObj,
          };
          authCtx.setIncomes((prevIncomes) => {
            return [income, ...prevIncomes];
          });
          authCtx.setTotalIncome((prev) => {
            return parseFloat(prev) + parseFloat(income.amount);
          });
        }
      });
  }

  function sourceChangeHandler(event) {
    setIncomeSource(event.target.value);
  }

  function amountChangeHandler(event) {
    setIncomeAmount(event.target.value);
  }
  function deleteIncome(id) {
    const url =
      "https://budgetmaster-1b6a5-default-rtdb.firebaseio.com/users/" +
      authCtx.localId +
      "/incomes/" +
      id +
      ".json?auth=" +
      authCtx.token;
    fetch(url, {
      method: "DELETE",
      header: {
        "Content/type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((res) => {
        let incomes = [];
        let a;
        for (let i = 0; i < authCtx.incomes.length; i++) {
          if (authCtx.incomes[i].id != id) {
            let inc = {
              source: authCtx.incomes[i].source,
              amount: authCtx.incomes[i].amount,
              id: authCtx.incomes[i].id,
            };
            incomes.push(inc);
          } else {
            a = parseFloat(authCtx.incomes[i].amount);
          }
        }
        authCtx.setTotalIncome((prev) => {
          return parseFloat(prev) - a;
        });
        authCtx.setIncomes(incomes);
      });
  }

  return (
    <>
      <div className="container">
        <h2 className="text-center enter">Add An Income Stream!</h2>
        <div className="row">
          <div className="expensesFormCont">
            <form onSubmit={addIncome}>
              <span className="form-group">
                <label className="catLab">Income Source: </label>
                <input
                  type="text"
                  required
                  placeholder="Software Engineering Job"
                  className="form-control col-md-1"
                  value={incomeSource}
                  onChange={sourceChangeHandler}
                ></input>
              </span>
              <span className="form-group">
                <label className="catLab ">Amount: </label>
                <input
                  type="number"
                  min="1"
                  required
                  placeholder="6000 (After Tax)"
                  className="form-control col-md-1"
                  value={incomeAmount}
                  onChange={amountChangeHandler}
                ></input>
              </span>
              <p className="buttondiv">
                <button
                  type="submit"
                  className="btn btn-primary mb-2 incomeSubmit"
                >
                  Add
                </button>
              </p>
            </form>
          </div>
          <div className="incomePart">
            <h1 className="myExp">Your Incomes</h1>
            <div>
              {authCtx.incomes.length == 0 ? (
                <p className="text-center">
                  <h2>Enter Your First Income!</h2>
                </p>
              ) : (
                authCtx.incomes &&
                authCtx.incomes.length > 0 &&
                authCtx.incomes.map((income) => (
                  <p className="expenseItem">
                    <h2 className="incomeName">
                      {income.source}: ${income.amount}
                    </h2>
                    <svg
                      onClick={() => {
                        deleteIncome(income.id);
                      }}
                      className="trashIcon"
                      fill="#1A1A1A"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="40px"
                      height="40px"
                    >
                      <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" />
                    </svg>
                  </p>
                ))
              )}
              {authCtx.incomes.length > 0 && (
                <h2>Total income: ${authCtx.totalIncome || 0}</h2>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Incomes;
